import React, { useEffect, useState } from 'react';
import'./Project.css'
// import Img1 from'../../assets/portfolio1.jpg'
// import Img2 from'../../assets/portfolio2.jpg'
// import Img3 from'../../assets/portfolio3.jpg'
import Img4 from'../../assets/portfolio4.jpg'
import Img5 from'../../assets/portfolio5.png'
import Img6 from'../../assets/portfolio6.jpg'

import Img1 from'../../assets/banner1.jpg'
import Img2 from'../../assets/banner2.1.jpg'
import Img3 from'../../assets/banner3.jpg'


// const projectData = [
//     [
//         {
//             "name": "MEGAPIXEL",
//             "image": "https://i.ibb.co/KWNsQmj/megapixel-3-2ratio.png",
//             "technologyUsed": [
//                 "React JS",
//                 "Node JS",
//                 "Express JS",
//                 "MongoDB",
//                 "JWT",
//                 "Authentication"
//             ],
//             "tools": [
//                 "Visual Studio Code",
//                 "Git"
//             ],
//             "packageUsed": "",
//             "description": "It's a online photography school where people can purchase course. Stripe payment method implemented. JWT implemented to secure website. REGEX implemented. Instructor can add course. Student can select class and enroll course throw payment. Admin can mange user and courses and also can give feedback",
//             "serverSide": "https://github.com/shiningsudipto/Megapixel-Server-Side",
//             "clientSide": "https://github.com/shiningsudipto/Megapixel-Client-Side",
//             "live": "https://megapixel-78f33.web.app/",
//             "slNumber": 1
//         },
//         {
//             "name": "SUPER TOYS",
//             "image": "https://i.ibb.co/FKSGXnH/super-toys-3-2.png",
//             "technologyUsed": [
//                 "React JS",
//                 "Node JS",
//                 "Express JS",
//                 "MongoDB"
//             ],
//             "tools": [
//                 "PyCharm",
//                 "GitHub"
//             ],
//             "description": "This is a full-stack website. This website is based on Action Toys like Avengers, DC Comics, and Transformers. Here people will get real information about added toys by clicking the view details button. If the user wants to see details then he/she must be logged in. User can register with email and password and also log in with Google. After logging in user will see 2 more menus Add a Toy and My Toys. User can add toys from Add A Toy page. User can see their added toys from the My Toys page. From the My Toys page user cat update and also can delete his/her added toys.",
//             "serverSide": "https://github.com/shiningsudipto/Super-Toys-Server-PHa11",
//             "clientSide": "https://github.com/shiningsudipto/Super-Toys-Client-PHa11",
//             "live": "https://super-toys-c5844.web.app/",
//             "slNumber": 2
//         },
//         {
//             "name": "DREAM FOOD",
//             "image": "https://i.ibb.co/F0mPN4B/Dream-Food-3-2.png",
//             "technologyUsed": [
//                 "React JS"
//             ],
//             "tools": [
//                 "PyCharm",
//                 "GitHub"
//             ],
//             "description": "This website based for food recipes of America. Here you will get top best chef of all time in America and their bio. There is 18 popular food recipe of there. This website built with . It's a JavaScript popular library. I added authentication system with firebase. If anyone want to see recipes of chef by clicking 'view recipe' then he/she will see the details of that chef and at least 3 recipe. If a visitor without logged in want to see recipes he/she will redirect to the login page. After log in or if he don't have any account also can create one. People can choose recipe of chef to see their popularity.",
//             "serverSide": "https://github.com/shiningsudipto/Dream-Food-Server-PHa10",
//             "clientSide": "https://github.com/shiningsudipto/Dream-Food-Client-PHa10",
//             "live": "https://dream-food.web.app/",
//             "slNumber": 3
//         }
    
// ]
// ]

// const data = [
//     {
//         id: 1,
//         image :Img1,
//         title:'Ancension Music Institute',
//         github:'https://github.com/ChowdhuryJoyanti/ascension-music-institute-client',
//         demo:'https://ascension-music-institute.web.app/'
        
//     },
//     {
//         id: 2,
//         image :Img2,
//         title:'Rhythmic Melody Studio',
//         github:'https://github.com/ChowdhuryJoyanti/crescendo-the-musical-toy-client',
//         demo:'https://rhythmic-melody-studio.web.app/'
        
//     },
//     {
//         id: 3,
//         image :Img3,
//         title:'Worldwide Famous Chefs ',
//         github:'https://github.com/ChowdhuryJoyanti/worldwide-famous-chefs-receipes-client',
//         demo:'https://worldwide-famous-chefs-receipe.web.app/'
        
//     },
//     {
//         id: 4,
//         image :Img4,
//         title:'Geometry Genius',
//         github:'https://github.com/ChowdhuryJoyanti/geomatry-genious-assignment',
//         demo:'https://eloquent-smakager-404665.netlify.app/'
        
//     },
//     {
//         id: 5,
//         image :Img5,
//         title:'Job Hunt',
//         github:'https://github.com/ChowdhuryJoyanti/job-hunt',
//         demo:'https://magical-daffodil-018e21.netlify.app/'
        
//     },
//     {
//         id: 6,
//         image :Img6,
//         title:'Knowledge Cafe',
//         github:'https://github.com/ChowdhuryJoyanti/Knoledge-cafe',
//         demo:'https://lucky-cassata-d3a10d.netlify.app/'
        
//     }
// ]





const truncateText = (text, maxLength) => {
   if (text.length <= maxLength) {
     return text;
   }
   return text.slice(0, maxLength) + '...';
 };



const Project = () => {

 const [data ,setData] = useState();

 useEffect(() => {
   //  fetch("https://portflio-backend.vercel.app/project")
   //  fetch("http://localhost:5000/project")
   //  fetch("https://portflio-backend.vercel.app/project")
    fetch("https://portfolio-server-tau-liart.vercel.app/api/projects")
    .then(res => res.json())
    .then(data => setData(data))


 },[])
//  const truncatedDescription = truncateText(data.title, 100);
    return (
        <section id='project'>
           <h5>My Recent Works</h5>
           <h2>Projects</h2>

           <div className="container project_container">
                   
                {
                   data?.data?.map((item) =>{
                        return(
                            <article key={item._id} className='project_item'>
                            <div className="project_item-image">
                               <img src={item.image} alt="" />
                            </div>
                            <h3>{item.title}</h3>
                             <div className="project_item-cta">
                             {/* <a href={item.client} className='btn btn-primary' target='_blank' rel="noreferrer">Git Hub</a> */}
                             {/* <a href={item.serverSiteLink} className='btn btn-primary' target='_blank' rel="noreferrer">Git Hub</a> */}



                                <a href={item.live}className='btn btn-primary'target='_blank' rel="noreferrer">Live Demo</a>


                                <div className="card-actions items-center">
          
          <button className="btn  btn-primary w-full" onClick={()=>document.getElementById(item._id).showModal()}>Read More</button>
      </div>
                             </div>
      

                             <div className="">

{/* <p>{item.description}</p> */}
{/* <p className='text-white m-5'>{truncatedDescription}</p> */}
  <hr />
 
</div>

{/* Open the modal using ID.showModal() method */}
<dialog id={item._id} className="modal modal-bottom sm:modal-middle">
  <form method="dialog" className="modal-box">
    <h3 className="font-semibold text-lg">{item.title}</h3>
   
    <p><span className='font-bold'>Technologies :</span> {item.technology}</p>
    <p className="py-4 text-justify"> <span className='font-bold'>Description:</span>  {item.description}</p>
    <a href={item.server}className='btn btn-primary'target='_blank' rel="noreferrer">server</a>
    <a href={item.client}className='btn btn-primary'target='_blank' rel="noreferrer">Client</a>
    <div className="modal-action">
      {/* if there is a button in form, it will close the modal */}
      <button className="btn btn-primary">Close</button>
    </div>
  </form>
</dialog>





                        </article>
                        )
                    })
                }






                    {/* <article className='project_item'>
                        <div className="project_item-image">
                           <img src={Img1} alt="" />
                        </div>
                        <h3>This is a Project Item Title</h3>
                         <div className="project_item-cta">
                         <a href="https://github.com" className='btn' target='_blank'>Git Hub</a>
                            <a href="https://github.com"className='btn btn-primary'target='_blank' >Live Demo</a>
                         </div>

                    </article>
                    <article className='project_item'>
                        <div className="project_item-image">
                           <img src={Img1} alt="" />
                        </div>
                        <h3>This is a Project Item Title</h3>
                         <div className="project_item-cta">
                         <a href="https://github.com" className='btn' target='_blank'>Git Hub</a>
                            <a href="https://github.com"className='btn btn-primary'target='_blank' >Live Demo</a>
                         </div>

                    </article>
                    <article className='project_item'>
                        <div className="project_item-image">
                           <img src={Img1} alt="" />
                        </div>
                        <h3>This is a Project Item Title</h3>
                         <div className="project_item-cta">
                         <a href="https://github.com" className='btn' target='_blank'>Git Hub</a>
                            <a href="https://github.com"className='btn btn-primary'target='_blank' >Live Demo</a>
                         </div>

                    </article>
                    <article className='project_item'>
                        <div className="project_item-image">
                           <img src={Img1} alt="" />
                        </div>
                        <h3>This is a Project Item Title</h3>
                         <div className="project_item-cta">
                         <a href="https://github.com" className='btn' target='_blank'>Git Hub</a>
                            <a href="https://github.com"className='btn btn-primary'target='_blank' >Live Demo</a>
                         </div>

                    </article>
                    <article className='project_item'>
                        <div className="project_item-image">
                           <img src={Img1} alt="" />
                        </div>
                        <h3>This is a Project Item Title</h3>
                         <div className="project_item-cta">
                         <a href="https://github.com" className='btn' target='_blank'>Git Hub</a>
                            <a href="https://github.com"className='btn btn-primary'target='_blank' >Live Demo</a>
                         </div>

                    </article> */}

                  
           </div>
        </section>
    );
};

export default Project;